import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-email-remove-outline.component',
  templateUrl: './icon-email-remove-outline.component.html',
  styleUrl: './icon-email-remove-outline.component.scss',
  standalone: false,
})
export class IconEmailRemoveOutlineComponent {
  @Input() tooltip?: string;
}
